var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{staticClass:"mb-12 pb-10 mb-md-0 pb-md-0"})}
var staticRenderFns = []

export { render, staticRenderFns }